const PieChart = () => {
    return (
        <>
            <div className="col-md-6 col-lg-4">
                <div className="card h-100">
                    <div className="card-header d-flex align-items-center justify-content-between">
                        <h5 className="card-title m-0 me-2">Total Balance</h5>
                        <div className="dropdown">
                            <button className="btn p-0" type="button" id="totalBalance" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="bx bx-dots-vertical-rounded" />
                            </button>
                            <div className="dropdown-menu dropdown-menu-end" aria-labelledby="totalBalance">
                                <a className="dropdown-item" href="javascript:void(0);">Last 28 Days</a>
                                <a className="dropdown-item" href="javascript:void(0);">Last Month</a>
                                <a className="dropdown-item" href="javascript:void(0);">Last Year</a>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="d-flex justify-content-start">
                            <div className="d-flex pe-4">
                                <div className="me-3">
                                    <span className="badge bg-label-warning p-2"><i className="bx bx-wallet text-warning" /></span>
                                </div>
                                <div>
                                    <h6 className="mb-0">$2.54k</h6>
                                    <small>Wallet</small>
                                </div>
                            </div>
                            <div className="d-flex">
                                <div className="me-3">
                                    <span className="badge bg-label-secondary p-2"><i className="bx bx-dollar text-secondary" /></span>
                                </div>
                                <div>
                                    <h6 className="mb-0">$4.2k</h6>
                                    <small>Paypal</small>
                                </div>
                            </div>
                        </div>
                        <div id="totalBalanceChart" className="border-bottom mb-3" />
                        <div className="d-flex justify-content-between">
                            <small className="text-muted">You have done <span className="fw-medium">57.6%</span> more sales.<br />Check your new badge in
                                your profile.</small>
                            <div>
                                <span className="badge bg-label-warning p-2"><i className="bx bx-chevron-right text-warning scaleX-n1-rtl" /></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
}

export default PieChart;